/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import AsyncSelect from 'react-select/async';
import { Option } from '../SelectInput/SelectInput';

type ReactSelectInputProps = {
  className?: string;
  name: string;
  id?: string;
  disabled?: boolean;
  error?: boolean;
  placeholder?: string;
  loadOptions: (inputValue: string) => Promise<Option[]>;
  value: Option | string | number;
  onChange?: (option: any) => void;
  onInputChange?: (value: string) => void;
  styles?: any;
  [x: string]: any;
};

function AsyncSelectInput({
  className,
  name,
  id,
  disabled,
  error,
  placeholder,
  loadOptions,
  onInputChange,
  value,
  onChange,
  styles,
  ...props
}: ReactSelectInputProps) {
  const customStyles = {
    menuList: (provided: any) => ({
      ...provided,
      fontSize: 16,
    }),
    ...(styles && { ...styles }),
  };

  return (
    <AsyncSelect
      {...props}
      className={`react-select-tailwind-container ${className} ${
        error ? 'border-pos-red' : ''
      }`}
      classNamePrefix="react-select-tailwind"
      id={id}
      name={name}
      placeholder={placeholder}
      isDisabled={disabled}
      value={value}
      defaultOptions
      loadOptions={loadOptions}
      onInputChange={onInputChange}
      onChange={onChange}
      styles={customStyles}
      theme={theme => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          primary25: '#ddf4ff',
          primary: '#2FAEF3',
        },
      })}
    />
  );
}

AsyncSelectInput.defaultProps = {
  className: '',
  placeholder: '',
  id: undefined,
  onInputChange: undefined,
  styles: undefined,
  onChange: undefined,
  disabled: false,
  error: false,
};

export default AsyncSelectInput;
